<span class="material-symbols-rounded" aria-hidden="true"> search </span>
<input
    type="text"
    [placeholder]="placeholder ?? 'PLACEHOLDERS.SEARCH' | translate"
    [(ngModel)]="value"
    (ngModelChange)="onModelChange($event)"
/>
